<template>
    <div>
        <div v-show="isMask" class="mask"></div>
        <div class="tab-item-pop">
            <div class="item-sale3">
                <div class="top-item">
                    <div class="title">
                        <i @click="collClick('orderShow1')"  style="cursor: pointer;" :class="[orderShow1 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                        <span  @click="collClick('orderShow1')"  style="cursor: pointer;">提报售点</span>
                    </div>
                    <div class="his-btn" @click="viewUpdate()">
                        查看历史变更记录
                    </div>
                </div>
                <div class="item-sale3-div2" v-show="orderShow1">
                    <div class="div-time" v-if="tableData.length > 0">
                        <div class="time-left">活动执行日期</div>
                        <div class="time-right">
                            <span>{{ getTimename(tableData[0].timeListno) }}</span>
                            <span style="color:#409EFF;margin-left: 10px;">{{ tableData[0].timeListno.length }}天</span>
                        </div>
                    </div>
                    <el-table
                        ref="multipleTable"
                        :data="tableData"
                        tooltip-effect="dark"
                        style="width: 100%"
                        border
                        show-header
                        :span-method="objectSpanMethod"
                        >
                        <!-- @selection-change="handleSelectionChange" -->
                        <el-table-column
                        align="center"
                        width="70"
                        show-overflow-tooltip
                        label="BU">
                        <template slot-scope="scope">
                            <span v-if="scope.row.buName !== null">
                                {{scope.row.buName.split('|')[0] }}
                            </span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="销售大区"
                        width="100"
                        show-overflow-tooltip
                        >
                        <template slot-scope="scope">
                            <span v-if="scope.row.regionName !== null">
                                {{scope.row.regionName.split('|')[0] }}
                            </span>
                        </template>
                        </el-table-column>
                        <!-- <el-table-column
                        v-if="!isEmptypoint"
                        align="center"
                        prop="cityName"
                        label="城市"
                        width="100"
                        show-overflow-tooltip>
                        </el-table-column> -->
                        <el-table-column
                        align="center"
                        label="城市"
                        width="100"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.areaName !== null">
                                {{scope.row.areaName.split('|')[0] }}
                            </span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        v-if="isManypoint || isEmptypoint"
                        :label="isEmptypoint? '活动地点':'街区名称'"
                        show-overflow-tooltip>
                        <template slot-scope="scope">{{ scope.row.blockName }}</template>
                        </el-table-column>
                        <el-table-column
                        v-if="!isEmptypoint"
                        align="center"
                        label="售点信息"
                        show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <!-- class="store-name" @click="clickStorename(scope.row)" -->
                                <div style="overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">
                                    <span>{{ scope.row.pocName }} </span>
                                    <span v-if="scope.row.pocName && scope.row.pocAddress">-</span>
                                    <span v-if="scope.row.pocAddress"> {{ scope.row.pocAddress }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                        v-if="!isEmptypoint"
                        align="center"
                        label="联系人信息"
                        show-overflow-tooltip
                        width="160"
                        >
                            <template slot-scope="scope">
                                    <i v-if="queryCondition == '06' &&  scope.row.activityStatus == 200 && routerType == 'update'"   class="el-icon-edit" @click="showUpdate(scope.row)" style="margin:0px 5px;color: #409EFF;cursor: pointer;"></i>
                                    <span>{{ scope.row.contactPerson }}</span>
                                    <span v-if="scope.row.contactPhone && scope.row.contactPerson">-</span>
                                    <span v-if="scope.row.contactPhone">{{ scope.row.contactPhone }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                        v-if="isEmptypoint"
                        align="center"
                        prop="blockAddress"
                        label="地址"
                        show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        prop="bwContactPerson"
                        label="百威联系人"
                        width="160"
                        show-overflow-tooltip>
                        </el-table-column>
                        <!-- <el-table-column
                        align="center"
                        label="活动时间"
                        width="90"
                        class="time-item"
                        v-if="false"
                        >
                        <template slot-scope="scope">
                            <div  class="pickerOptionsNo"  style="display:flex;">
                                <div style="color:#409eff;margin:auto;" >
                                    {{ scope.row.timeListno.length }}天
                                    <i class="el-icon-date" style="color:#409eff;cursor: pointer;" @click="clickDate2(scope.row)"></i>
                                </div>
                                <el-date-picker
                                style="width:0px;overflow: hidden;"
                                :ref=" 'changeFocus2' + (scope.row.activityId)"
                                popper-class="elDatePicker"
                                @change="changeTime(scope.row)"
                                type="dates"
                                value-format="yyyy-MM-dd"
                                v-model="scope.row.timeListno"
                                :picker-options="pickerOptionsNo(themeBasic)"
                                placeholder="选择一个或多个日期"
                                size="small"
                                :clearable="false"
                                class="date-picker"
                                :default-value="defauleTime"
                                >
                                </el-date-picker>
                            </div>
                        </template>
                        </el-table-column> -->
                        <el-table-column
                        v-if="isManypoint && queryCondition == '03'"
                        align="center"
                        label="退回标记"
                        width="80"
                        >
                            <template slot-scope="scope">
                                <div  v-if="(scope.row.rejectStatus !== null)">
                                    <img style="width:20px" src="../../../assets/images/gameplan-return.png" alt="">
                                    <!-- <el-tag type="danger" size="mini">退回</el-tag> -->
                                </div>
                                <div v-else>
                                    <img style="width:20px" src="../../../assets/images/gameplan-return2.png" alt="">
                                    <!-- <el-tag type="warning" size="mini">未退回</el-tag> -->
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                        align="center"
                        label="提报状态"
                        width="110"
                        show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.activityStatus == 0">待提交</span>
                                <span v-else-if="scope.row.activityStatus == 100">Region审批</span>
                                <span v-else-if="scope.row.activityStatus == 200">BU审批</span>
                                <span v-else-if="scope.row.activityStatus == 300">HQ审批</span>
                                <span v-else-if="scope.row.activityStatus == 350">待供应商确认</span>
                                <span v-else-if="scope.row.activityStatus == 400">执行中</span>
                                <span v-else-if="scope.row.activityStatus == 500">已完成</span>
                                <span v-else-if="scope.row.activityStatus == 900">已关闭</span>
                                <span v-else-if="scope.row.activityStatus == 1000">
                                    <!-- HQ/BU退回 -->
                                    <span v-if="scope.row.rejectClientLevel == 'hq'">
                                        HQ退回
                                    </span>
                                    <span v-else-if="scope.row.rejectClientLevel == 'bu'">
                                        BU退回
                                    </span>
                                    <span v-else>
                                        HQ/BU退回
                                    </span>
                                </span>
                                <span v-else>未知</span>
                            </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="queryCondition == '06' && routerType == 'update'"
                        align="center"
                        label="操作"
                        width="200"
                        >
                        <template slot-scope="scope">
                            <div v-if=" scope.row.activityStatus == 200" style="display:flex;justify-content: center;margin:auto;">
                                <div  class="store-name" style="display: flex;margin-right:10px;" >
                                    <div style="color:#409eff;cursor: pointer;" @click="clickDate1(scope.row)" >
                                        <span>修改活动日期</span>
                                    </div>
                                    <DatePicker
                                      :ref="'changeFocus1' + (scope.row.activityId)"
                                      align="right"
                                      style="width:0px;overflow: hidden;"
                                      :readonly="false"
                                      :activityId="scope.row.activityId.toString()"
                                      :theme-start-time="themeBasic.themeStartTime"
                                      :theme-end-time="themeBasic.themeEndTime"
                                      @handleChangeDate="handleChangeDate"
                                      />
                                    <!-- <el-date-picker
                                    align="right"
                                    style="width:0px;overflow: hidden;"
                                    @change="changeTime(scope.row)"
                                    @focus="focusInput(scope.row)"
                                    type="dates"
                                    value-format="yyyy-MM-dd"
                                    v-model="scope.row.timeList"
                                    :picker-options="pickerOptions(themeBasic)"
                                    placeholder="选择一个或多个日期"
                                    size="small"
                                    clearable
                                    :default-value="defauleTime"
                                    >
                                    </el-date-picker> -->
                                </div>
                                <div style="margin-right:10px;" class="store-name" >
                                    <div  @click="clickOperate(scope.row)">
                                        换店
                                    </div>
                                </div>
                                <div  class="store-name">
                                    <el-popconfirm
                                    @confirm="deleteRow(scope.row)"
                                    confirm-button-text='确认'
                                    cancel-button-text='取消'
                                    icon="el-icon-info"
                                    icon-color="red"
                                    title="是否确认删除？"
                                    >
                                    <div slot="reference">删除</div>
                                    </el-popconfirm>
                                </div>
                            </div>
                            <div v-else style="color:#cd1231;">
                                不可修改
                            </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="queryCondition == '02' && routerType == 'update'"
                        align="center"
                        label="操作"
                        width="140"
                        >
                        <template slot-scope="scope">
                            <div  class="store-name" style="display: flex;" >
                                <div style="color:#409eff;margin:auto;cursor: pointer;" @click="clickDate3(scope.row)" >
                                    <span>修改活动日期</span>
                                </div>
                                <DatePicker
                                      :ref="'changeFocus3' + (scope.row.activityId)"
                                      align="right"
                                      style="width:0px;overflow: hidden;"
                                      :readonly="false"
                                      :activityId="scope.row.activityId.toString()"
                                      :theme-start-time="themeBasic.themeStartTime"
                                      :theme-end-time="themeBasic.themeEndTime"
                                      @handleChangeDate="handleChangeDate"
                                      />
                                <!-- <el-date-picker
                                align="right"
                                style="width:0px;overflow: hidden;"
                                @change="changeTime(scope.row)"
                                @focus="focusInput(scope.row)"
                                type="dates"
                                value-format="yyyy-MM-dd"
                                v-model="scope.row.timeList"
                                :picker-options="pickerOptions(themeBasic)"
                                placeholder="选择一个或多个日期"
                                size="small"
                                clearable
                                :default-value="defauleTime"
                                >
                                </el-date-picker> -->
                            </div>
                        </template>
                        </el-table-column>
                        <el-table-column
                        v-if="queryCondition == '03'"
                        align="center"
                        label="退回人"
                        width="80"
                        show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.rejectClientName">{{scope.row.rejectClientName}}</span>
                                <span v-else>暂无数据</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                        v-if="queryCondition == '03'"
                        align="center"
                        label="退回理由"
                        show-overflow-tooltip
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.submitRejectReason">{{scope.row.submitRejectReason}}</span>
                                <span v-else>暂无理由</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <!-- 提报数据部分 -->
        <div class="report" v-if="routerType == 'view' && queryCondition !== '03'">
            <div class="title">
                <i @click="collClick('orderShow2')"  style="cursor: pointer;" :class="[orderShow2 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                <span @click="collClick('orderShow2')"  style="cursor: pointer;">提报数据</span>
            </div>
            <div class="report-main"  v-show="orderShow2">
                <el-table
                    :data="inventoryList"
                    show-header
                    border
                    style="width: 100%"
                    :span-method="objectSpanMethod3"
                    >
                    <el-table-column
                    v-if="isManypoint"
                    prop="blockName"
                    label="街区名称"
                    align="center"
                    width="200"
                    show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                    prop="pocName"
                    :label="isEmptypoint ? '活动地点':'售点名称' "
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="timeSign"
                    label="日期"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    label="操作"
                    align="center"
                    >
                        <template slot-scope="scope">
                            <div  class="store-name">
                                <div style="color:#409eff;margin:auto;cursor: pointer;" @click="viewDetail(scope.row)" >
                                    <span>查看详情</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <!-- 照片审核部分 -->
        <div class="photoPop" v-if="routerType == 'view' && queryCondition !== '03' && activityInfo.imageApprovalList && activityInfo.imageApprovalList.length > 0">
            <div class="title">
                <i @click="collClick('orderShow3')"  style="cursor: pointer;" :class="[orderShow3 ? 'el-icon-caret-bottom' : 'el-icon-caret-right']"></i>
                <span @click="collClick('orderShow3')" style="cursor: pointer;">照片审核记录</span>
            </div>
            <div class="photo-approval" v-if="orderShow3 && activityInfo.imageApprovalList && activityInfo.imageApprovalList.length > 0">
            <div
                v-for="approval in activityInfo.imageApprovalList"
                :key="approval.imageApprovalId"
                class="photo-approval-card is-hover-shadow"
                :class="{ 'photo-approval-card-selected': checkApprovalSelected(approval) }">
                <el-row>
                <el-col :span="16">
                    <div class="approval-request-time">
                    提交时间：{{ getDateTime(approval.requestTime) }}
                    </div>
                </el-col>
                <el-col :span="8" class="approval-code">
                    <span>
                    申请单号：{{ approval.imageApprovalCode }}
                    </span>
                </el-col>
                </el-row>
                <el-row>
                <el-col :span="20">
                    <PhotoStep :active="getActivestep(approval)" :stepList="stepList"></PhotoStep>
                </el-col>
                <el-col :span="4" class="approval-view-link">
                    <span @click="viewApprovalImage(approval)">查看照片详情</span>
                </el-col>
                </el-row>
            </div>
            </div>

            <div class="photo-fieldBuild" v-show="orderShow3" v-for="itemType in imageApprovalInfo.responseImageList" :key="itemType.imageType">
            <div class="title">
                <div class="left">{{ itemType.imageTypeName }}</div>
                <div class="right">
                <span v-if="imageApprovalInfo.evidenceStatus == 500">已审批</span>
                <span v-else-if="imageApprovalInfo.evidenceStatus == 0 || imageApprovalInfo.evidenceStatus == 900">待提交</span>
                <span v-else>审批中</span>
                </div>
            </div>
            <div v-if="itemType.imageType == '01'" class="photo-fieldBuild-card1 is-hover-shadow">
                <div class="card-item" v-for="itemDecorate1 in itemType.activityImageList" :key="itemDecorate1.decorateType">
                <div class="top">{{ itemDecorate1.decorateTypeName }}</div>
                <div class="photo">
                    <div class="photo-item" v-for="itemImage,index1 in itemDecorate1.imageList" :key="itemImage.activityImageId">
                    <el-image  :initial-index="index1" :src="getImgList(itemDecorate1.imageList)[index1]" :preview-src-list="getImgList(itemDecorate1.imageList)" class="photo-item-image" />
                    <!-- <img class="photo-item-image" @click="clickImg('/' + itemImage.imageUri,itemDecorate1.imageList,index1)" :src="getImg('/' + itemImage.imageUri)" alt=""> -->
                    </div>
                </div>
                </div>
            </div>

            <div v-else-if="itemType.imageType == '02'" class="photo-fieldBuild-card2 is-hover-shadow">
                <div class="card-item" v-for="itemDecorate2 in itemType.activityImageList" :key="itemDecorate2.decorateType">
                <div class="top">{{ itemDecorate2.decorateTypeName }}</div>
                <div class="photo">
                    <div class="photo-item" v-for="itemImage,index2 in itemDecorate2.imageList" :key="itemImage.activityImageId">
                    <el-image  :initial-index="index2" :src="getImgList(itemDecorate2.imageList)[index2]" :preview-src-list="getImgList(itemDecorate2.imageList)" class="photo-item-image" />
                    <!-- <img class="photo-item-image" @click="clickImg('/' + itemImage.imageUri,itemDecorate2.imageList,index2)" :src="getImg('/' + itemImage.imageUri)" alt=""> -->
                    </div>
                </div>
                </div>
            </div>

            <div v-else>
                <div class="photo-fieldBuild-card2 is-hover-shadow" v-for="itemDate in itemType.activityImageList" :key="itemDate.activityDate">
                <div class="execution-time">
                    执行时间：{{ itemDate.activityDate }}
                </div>
                <div
                    class="card-item"
                    v-for="itemDecorate3 in itemDate.activityImageList"
                    :key="itemDecorate3.decorateType"
                >
                    <div class="top">{{ itemDecorate3.decorateTypeName }}</div>
                    <div class="photo">
                    <div
                        class="photo-item"
                        v-for="itemImage,index3 in itemDecorate3.activityImageList"
                        :key="itemImage.activityImageId"
                    >
                        <el-image  :initial-index="index3" :src="getImgList(itemDecorate3.activityImageList)[index3]" :preview-src-list="getImgList(itemDecorate3.activityImageList)" class="photo-item-image" />
                        <!-- <img class="photo-item-image" @click="clickImg('/' + itemImage.imageUri,itemDecorate3.activityImageList,index3)" :src="getImg('/' + itemImage.imageUri)" alt=""> -->
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>

        </div>
        <div  v-show="(isSinglepoint && isSingledialog) || ( isManypoint && isManydialog)" class="dialog">
            <SinglePoint
            v-if="isSinglepoint && isSingledialog"
            :options="igniteOptions"
            :searchList="searchList"
            @closeMask="closeMask"
            @handleChange="handleChange" ></SinglePoint>
            <ManyPoint
            v-if="isManypoint && isManydialog "
            :options="igniteOptions"
            :searchList="searchList"
            @closeMask="closeMask"
            @handleSelectionChange="handleSelectionChange"></ManyPoint>
        </div>
        <div  v-show="isEmptypoint && isEmptydialog" class="dialog2">
            <EmptyPoint
            v-if="isEmptypoint && isEmptydialog "
            :options="igniteOptions"
            :searchList="searchList"
            @closeMask="closeMask"
            @handleEmptyChange="handleEmptyChange"></EmptyPoint>
        </div>
        <!-- 单售点审批中修改 -->
        <div class="dialog-update" v-if="isUpdatesingle && isSinglepoint" >
            <el-table
            :data="updatedList"
            ref="updateTable"
            show-header
            border
            class="update-table"
            style="width: 100%">
            <el-table-column
            prop="pocName"
            label="售点名称"
            align="center"
            width="200"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="售点联系人"
            align="center"
            >
            <template slot-scope="scope">
                <el-input class="item-input" size="mini" v-model="scope.row.contactPerson"   clearable>{{ scope.row.contactPerson }}</el-input>
            </template>
            </el-table-column>
            <el-table-column
            label="联系人手机号"
            align="center"
            >
            <template slot-scope="scope">
                <el-input  class="item-input" size="mini" v-model="scope.row.contactPhone"   clearable>{{ scope.row.contactPhone }}</el-input>
            </template>
            </el-table-column>
            <el-table-column
            label="百威联系人"
            align="center"
            >
            <template slot-scope="scope">
                <el-input  class="item-input" size="mini" v-model="scope.row.bwContactPerson"  @change="changeInput(scope.row)" clearable>{{ scope.row.bwContactPerson }}</el-input>
            </template>
            </el-table-column>
        </el-table>
        <div class="dialog-btn2">
            <div class="btn-left" @click="closeSure()" >取消</div>
            <div class="btn-right"  @click= 'updateSure()'>确定</div>
        </div>
        </div>
        <!-- 多售点审批中修改 -->
        <div class="dialog-update" v-if="isUpdatemany && isManypoint"  >
        <el-table
            :data="updatedList"
            ref="updateTable"
            show-header
            border
            class="update-table"
            max-height="450"
            :span-method="objectSpanMethod2"
            style="width: 100%">
            <el-table-column
            prop="blockName"
            label="街区名称"
            align="center"
            width="120"
            show-overflow-tooltip
            >
            </el-table-column>

            <el-table-column
            prop="pocName"
            label="售点名称"
            align="center"
            width="180"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="售点联系人"
            align="center"
            >
            <template slot-scope="scope">
                <el-input class="item-input" size="mini" v-model="scope.row.contactPerson"   clearable>{{ scope.row.contactPerson }}</el-input>
            </template>
            </el-table-column>
            <el-table-column
            label="联系人手机号"
            align="center"
            >
            <template slot-scope="scope">
                <el-input  class="item-input" size="mini" v-model="scope.row.contactPhone"   clearable>{{ scope.row.contactPhone }}</el-input>
            </template>
            </el-table-column>
            <el-table-column
            label="百威联系人"
            align="center"
            >
            <template slot-scope="scope">
                <el-input  class="item-input" size="mini" v-model="scope.row.bwContactPerson"  @change="changeInput(scope.row)" clearable>{{ scope.row.bwContactPerson }}</el-input>
            </template>
            </el-table-column>
        </el-table>
        <div class="dialog-btn2">
            <div class="btn-left" @click="closeSure()" >取消</div>
            <div class="btn-right"  @click= 'updateSure()'>确定</div>
        </div>
        </div>
        <!-- 提报数据查看详情 -->
        <div v-if="isShowDetail">
            <reportConfigPop @closeChangepop="closeDetail" :themeDetail="themeDetail" :params="paramsPop"></reportConfigPop>
        </div>
        <!-- <div v-if="isShowupdate">
            <reportUpdatePop @closeChangepop="closeDetail" :params="paramsPop"></reportUpdatePop>
        </div> -->
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { commonUtils } from "@/utils/common";
    import gameplanApi  from '../../../api/gameplan'
    import SinglePoint from './activity-report-single-point.vue'
    import ManyPoint from './activity-report-many-point.vue'
    import EmptyPoint from './activity-report-empty-point.vue'
    import PhotoStep from "../components/photo-step";
    import reportConfigPop from './report-config-pop.vue';
    import reportUpdatePop from './report-update-pop.vue';
    import DatePicker from "./date-picker.vue";
    import { parseTime } from '@/filters'
    export default {
      name: 'activity-report-pop-table',
      props: {
        popDataitem:{type:Object, default:()=>{}},
        queryCondition:{type:String},
        igniteOptions:{type:Object, default:()=>{} },
        themeBasic:{type:Object, default:()=>{} },
        regionCode:{type:String, default:'' },
        timeList:{type:[], default:()=>[] },
        detailDTOList:{type:Array, default: () => []},
        igniteRuleDTOList:{type:Array, default: () => []},
        routerType:{type:String, default:'' },
      },
      components: {
        SinglePoint,
        ManyPoint,
        EmptyPoint,
        PhotoStep,
        reportConfigPop,
        reportUpdatePop,
        DatePicker
      },
      data () {
        return {
            tableData: [],
            themeDetail:{},
            multipleSelection: [],
            streetArr: [], // 街道数组
            streeIndex:0, // 下标
            streetArr2: [], // 街道数组
            streeIndex2:0, // 下标
            streetArr3: [], // 街道数组
            streeIndex3:0, // 下标
            searchForm: {
                page: 1,
                pageSize: 5,
                total:0,
                buName:'',
                regionName:'',
                beginTime:'',
                endTime:'',
                assignId:''
            },
            isSinglepoint: false, // 单售点
            isManypoint: false, // 多售点
            isEmptypoint: false, // 无售点
            isSingledialog: false, // 单售点
            isManydialog: false, // 多售点
            isEmptydialog: false,// 无售点
            isMask: false,
            searchList: {},
            rowActivityId:'', //点击的活动id
            rowActivityList:[],
            rowBlockname:'',
            rowAreacode:'',
            rowBwContactPerson:'',
            rowNumber:'', //当前兼职的剩余数量
            rowApprovalnunumber:'', //当前兼职的审批数量
            isUpdatesingle: false,
            isUpdatemany: false,
            isUpdateempty: false,
            updatedList: [],
            rowUpdatalist:[],
            signInfo:false,// 修改位置标识字段
            pickerOptions(row = {}) {
                // console.log(row,'row');
                // time.getTime() < Date.now() - 8.64e7
                return{
                    disabledDate (time) {
                        return time.getTime() > row.themeEndTime ||  time.getTime() < row.themeStartTime
                    }
                }
            },
            pickerOptionsNo(row = {}) {
                return{
                    disabledDate (time) {
                        return true
                    },
                }
            },
            regionCodenew: '',
            defauleTime: '',
            ingiteNew: null,
            rowTimebegin:[],
            inventoryList: [], // 商品明细列表
            reportList: [], // 提报列表
            isShowDetail: false,// 展示查看详情弹窗
            activityInfo: {},
            imageApprovalInfo: {},
            stepList:[],
            orgLevel: '',
            paramsPop:{},
            isShowupdate: false,
            orderShow1: true,
            orderShow2: true,
            orderShow3: true,
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {
      },
      created () {
        // console.log(this.routerType,"routerType");
        // console.log(this.queryCondition,'queryCondition');
        // console.log(this.popDataitem,'popDataitem');
        this.searchForm.beginTime = this.timeList[0].assignStartTime
        this.searchForm.endTime = this.timeList[0].assignEndTime
        this.searchForm.assignId = this.timeList[0].assignId
        this.popData = this.popDataitem
        this.themeDetail =  this.popDataitem.themeDetail
        this.pocCountMin =  this.popDataitem.themeDetail.pocCountMin
        // if (this.popDataitem.themeLevelCode !== null) {
        //     this.popData = this.popDataitem
        //     this.themeDetail =  this.popDataitem.themeDetail
        //     this.pocCountMin =  this.popDataitem.themeDetail.pocCountMin
        // } else {
        //     this.popData = this.popDataitem.data[0]
        //     this.themeDetail =  this.popDataitem.data[0].themeDetail
        //     this.pocCountMin =  this.popDataitem.data[0].themeDetail.pocCountMin
        // }
        if (this.themeDetail.pocRelateType == '1') {
            this.isSinglepoint = true
            this.isManypoint = false
            this.isEmptypoint = false

        } else if (this.themeDetail.pocRelateType == '2') {
            this.isSinglepoint = false
            this.isManypoint = true
            this.isEmptypoint = false
        } else {
            this.isSinglepoint = false
            this.isManypoint = false
            this.isEmptypoint = true
        }
        this.init()
      },
      mounted () {},
      updated () {
      },
      methods: {
        init () {
            this.getDetailinfo()
            this.getPhoto()
        },
        collClick (name) {
            if (name == 'orderShow1') {
                this.orderShow1 = !this.orderShow1
            } else if (name == 'orderShow2') {
                this.orderShow2 = !this.orderShow2
            } else if (name == 'orderShow3') {
                this.orderShow3 = !this.orderShow3
            }
        },
        getTimename (timeListno) {
            // let  timeListno = ['2023-04-20','2023-04-22','2023-04-23','2023-04-24','2023-04-25']
            if (timeListno) {
                let name = ''
                name = timeListno.map((item)=>{
                    return item
                }).join(' | ')
                return name
            } else {
                return 'null'
            }
        },
        getPhoto () {
            this.activityInfo = this.popData.gpActivityInfoVOList[0].gpActivityInfoDTO || {}
            // this.orgLevel =  this.popData.gpActivityInfoVOList[0].gpActivityInfoDTO.orgLevel
            this.orgLevel =  this.popData.themeBasic.orgLevel
            if ( this.popData.gpActivityInfoVOList[0].gpActivityInfoDTO.imageApprovalList) {
                this.imageApprovalInfo = this.popData.gpActivityInfoVOList[0].gpActivityInfoDTO.imageApprovalList[0]
            }
            if (this.orgLevel == 'hq') {
                this.stepList = [
                    {
                        name: "",
                        index: 1,
                        title: "照片待提交",
                        title1: "照片提交中",
                        title2: "照片已提交",
                    },
                    {
                        name: "",
                        index: 2,
                        title: "HQ待审批",
                        title1: "HQ审批中",
                        title2: "HQ已审批",
                    },
                ]
            } else if (this.orgLevel == 'bu') {
                this.stepList = [
                {
                    name: "",
                    index: 1,
                    title: "照片待提交",
                    title1: "照片提交中",
                    title2: "照片已提交",
                },
                {
                    name: "",
                    index: 2,
                    title: "BU待审批",
                    title1: "BU审批中",
                    title2: "BU已审批",
                }
                ]
            }
            else if (this.orgLevel == 'region') {
                this.stepList = [
                {
                    name: "",
                    index: 1,
                    title: "照片待提交",
                    title1: "照片提交中",
                    title2: "照片已提交",
                },
                {
                    name: "",
                    index: 2,
                    title: "Region待审批",
                    title1: "Region审批中",
                    title2: "Region已审批",
                }
                ]
            }
            else{
                return
            }
        },
        async getDetailinfo () {
            let params = {
                'activityId':this.popData.gpActivityInfoVOList[0].gpActivityInfoDTO.activityId,
                'themeDetailId':this.popData.themeDetail.themeDetailId
            }
            let {data} = await gameplanApi.getGamepalnDetail(params)
            if (data.resultCode == '0') {
                let tableList = data.resultData.themeDetailInfo.gpActivityInfoVOList
                if (tableList !== null) {
                    if (!this.isEmptypoint) {
                        let arr = []
                        for (let index = 0; index < tableList.length; index++) {
                            let blockName = tableList[index].gpActivityInfoDTO.blockName
                            let buName = tableList[index].gpActivityInfoDTO.buName
                            let regionName = tableList[index].gpActivityInfoDTO.regionName
                            let activityStatus = tableList[index].gpActivityInfoDTO.activityStatus
                            let bwContactPerson = tableList[index].gpActivityInfoDTO.bwContactPerson
                            let areaCode = tableList[index].gpActivityInfoDTO.areaCode
                            let areaName = tableList[index].gpActivityInfoDTO.areaName
                            let regionCode =  tableList[index].gpActivityInfoDTO.regionCode
                            let submitRejectReason = tableList[index].gpActivityInfoDTO.submitRejectReason
                            let rejectClientName = tableList[index].gpActivityInfoDTO.rejectClientName
                            let rejectClientLevel = tableList[index].gpActivityInfoDTO.rejectClientLevel

                            if (tableList[index].gpActivityTimeDTOList == null) {
                                tableList[index].gpActivityTimeDTOList = []
                            }
                            let timeList = tableList[index].gpActivityTimeDTOList.map(item =>{
                                return item.activityTime
                            })
                            if (tableList[index].gpActivityPocDTOList !== null) {
                                for (let item of  tableList[index].gpActivityPocDTOList) {
                                    item.blockName = blockName
                                    item.buName = buName
                                    item.regionName = regionName
                                    item.activityStatus = activityStatus
                                    item.bwContactPerson = bwContactPerson
                                    item.areaCode = areaCode
                                    item.areaName = areaName
                                    item.timeList = timeList
                                    item.timeListno = timeList
                                    item.regionCode = regionCode
                                    item.submitRejectReason = submitRejectReason
                                    item.rejectClientName = rejectClientName
                                    item.rejectClientLevel = rejectClientLevel
                                    arr.push(item)
                                }
                            }
                        }
                        this.tableData = arr
                    } else {
                        let arr = []
                        for (let index = 0; index < tableList.length; index++) {
                            if (tableList[index].gpActivityTimeDTOList == null) {
                                tableList[index].gpActivityTimeDTOList = []
                            }
                            let timeList = tableList[index].gpActivityTimeDTOList.map(item =>{
                            return item.activityTime
                            })
                            tableList[index].gpActivityInfoDTO.timeList = timeList
                            tableList[index].gpActivityInfoDTO.timeListno = timeList
                            tableList[index].gpActivityInfoDTO.pocName = tableList[index].gpActivityInfoDTO.blockName
                            arr.push(tableList[index].gpActivityInfoDTO)
                        }
                        this.tableData = arr
                    }
                    this.merge(this.tableData)
                    let tableData = JSON.parse(JSON.stringify(this.tableData))
                    let  inventoryList = []
                    for (let item1 of tableData) {
                        for (let item2 of item1.timeList) {
                            inventoryList.push({...item1,'timeSign': item2})
                        }
                    }
                    // console.log(inventoryList,'inventoryList');
                    this.inventoryList = inventoryList
                    this.merge3(this.inventoryList)
                } else {
                    this.tableData = []
                    this.inventoryList = []
                }
            }
        },
        viewUpdate () {
            // this.isMask = true
            // this.isShowupdate = true
            // this.lockScroll()
            this.$router.push({
                path: '/gameplan/activity-history',
                query: {
                    'activityId':this.popData.gpActivityInfoVOList[0].gpActivityInfoDTO.activityId,
                    'pocRelateType':this.themeDetail.pocRelateType
                }
            })
        },
        // 获取提报信息
        async getReportdetail(params) {
            let data = await gameplanApi.getReportdetail(params);
            if (data.data.resultCode == "0") {
                this.isMask = true
                this.isShowDetail = true
                this.lockScroll()
            }
        },
        //售点查看详情
        viewDetail (row) {
            let params = {
                activityId: row.activityId,
                activityTime: row.timeSign,
                pocAbiId: row.igniteId
            }
            this.getReportdetail(params)
            this.paramsPop = params
            // this.isMask = true
            // this.isShowDetail = true
            // this.lockScroll()
        },
        // 关闭详情弹窗
        closeDetail () {
            this.isMask = false
            this.isShowDetail = false
            // this.isShowupdate = false
            this.unlockScroll()
        },
        // 点击图标显示日期组件
        clickDate1 (row) {
            let min = Math.min(...row.timeList.map(item => new Date(item)));
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            const newDateList = row.timeList.map(item=>{
              const date = new Date(item.replace(/-/g, '/'))
              return date.getTime()
            })
            this.$nextTick(()=>{
                this.$refs[`changeFocus1${row.activityId}`].showDatePicker(newDateList,row)
            })
        },
        clickDate2 (row) {
            let min = Math.min(...row.timeList.map(item => new Date(item)));
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            this.$nextTick(()=>{
                this.$refs[`changeFocus2${row.activityId}`].focus()
            })
        },
        clickDate3 (row) {
            let min = Math.min(...row.timeList.map(item => new Date(item)));
            this.defauleTime = new Date(min);
            this.defauleTime.setMonth(new Date(min).getMonth());
            const newDateList = row.timeList.map(item=>{
              const date = new Date(item.replace(/-/g, '/'))
              return date.getTime()
            })
            this.$refs[`changeFocus3${row.activityId}`].showDatePicker(newDateList,row)
        },
        // GP查询活动排班信息
        async queryGpactivitydatail (gpParams) {
            let res = await gameplanApi.queryGpactivitydatail(gpParams)
        },
        focusInput (row) {
            this.rowTimebegin = row.timeList
            // console.log(row,'focusInput');
        },
        handleChangeDate(selectList,activityId,row){
            const itemList = this.tableData.filter(item=>{
                return item.activityId == row.activityId
            })
            if(itemList.length!==0){
              selectList.sort((a, b) => {
                return new Date(a.replace(/-/g, '/')) <new Date(b.replace(/-/g, '/')) ? -1 : 1
                // return a < b ? -1 : 1
              })
              itemList[0].timeList = selectList
            }
            this.changeTime(itemList[0])
        },
        // 时间修改
        changeTime (row) {
            // console.log(row,'changeTime');
            for (let item of this.detailDTOList) {
                if (item.regionCode == row.regionCode) {
                    this.rowNumber = item.notReportCountQty
                    this.rowApprovalnunumber = item.approvalCountQty
                }

            }
            let manyArr = []
            this.rowActivityId = row.activityId
            this.rowAreacode = row.areaCode
            if (this.isManypoint) {
                for (let item of this.tableData) {
                    if (item.activityId == row.activityId) {
                        item.timeList = row.timeList
                        manyArr.push(item)
                    }
                }
            }
            if (this.themeDetail.needTransitions == 0) {
                if (this.themeDetail.perExecDays) {
                    if (row.timeList.length  !== this.themeDetail.perExecDays) {
                        this.$message.error(`选择日期天数应与执行天数相等,当前已选 ${row.timeList.length}天，应选 ${this.themeDetail.perExecDays}天`)
                        // if (row.timeList.length - this.themeDetail.perExecDays > 0) {
                        //     // row.timeList = row.timeList.slice(row.timeList.length - this.themeDetail.perExecDays,row.timeList.length)
                        //     row.timeList = row.timeList.slice(0,this.themeDetail.perExecDays)
                        // }
                        // if (row.timeList.length - this.themeDetail.perExecDays < 0) {
                        //     row.timeList = this.rowTimebegin
                        // }
                        this.$emit('activityChanged')
                        this.getDetailinfo()
                        return
                }
                } else {
                    this.$message.warning('配置天数未返回')
                    return
                }
            }
            if (row.timeList.length === row.timeListno.length ) {
                let changeArr = row.timeList.filter(t => !row.timeListno.includes(t))
                if (changeArr.length == 0) {
                    // console.log(changeArr,'changeArr');
                    this.$message.warning('修改日期与原日期一致,请重新修改')
                    return
                }
            }
            this.signInfo = true
            // 执行中调用gp临促查询
            if (this.queryCondition == '02' && this.routerType == 'update' && this.themeDetail.needSpr == '1') {
                let gpParams = {
                    'activityId': row.activityId,
                    'newTimeList':row.timeList
                }
                // this.queryGpactivitydatail(gpParams)
                let that = this
                function callerFun(){
                     gameplanApi.queryGpactivitydatail(gpParams).then((res) =>{
                        let data = res
                        if (data) {
                            that.$confirm('是否确认修改?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning'
                            }).then(() => {
                                if (that.isSinglepoint) {
                                    let arr = []
                                    arr.push(row)
                                    that.handleChange(arr)
                                } else if (that.isManypoint) {
                                    that.handleSelectionChange(manyArr)
                                } else if (that.isEmptypoint) {
                                    let arr = []
                                    arr.push(row)
                                    that.handleEmptyChange(arr)
                                } else {
                                    return
                                }
                            }).catch(() => {})
                        }
                    })
                }
                callerFun()
            } else {
                if (this.isSinglepoint) {
                    let arr = []
                    arr.push(row)
                    this.handleChange(arr)
                } else if (this.isManypoint) {
                    this.handleSelectionChange(manyArr)
                } else if (this.isEmptypoint) {
                    let arr = []
                    arr.push(row)
                    this.handleEmptyChange(arr)
                } else {
                    return
                }
            }
        },
        getTimetext (arr) {
            if (arr.length > 0) {
                arr.map(item =>{
                    return item.activityTime
                }).join('、')
                return arr
            } else {
                return '暂无数据'
            }
        },
        // 获取结束时间
        changeBegintime (val) {
            // console.log(val,'val-获取开始时间');
            if (val) {
                for (let item1 of this.timeList) {
                    if (item1.assignId == val) {
                        this.searchForm.beginTime = item1.assignStartTime
                        this.searchForm.endTime = item1.assignEndTime
                    }
                }
            } else {
                this.$message.warning('时间不能为空')
            }
            // console.log(this.searchForm.endTime,'val-获取结束时间');
        },
        // 初始化合并行数组
        mergeInit2() {
            this.streetArr2 = []; //合并街道
            this.streeIndex2 = 0; //合并街道索引
        },
    //  合并表格
        merge2(data) {
            this.mergeInit2();
            if (data.length > 0 && this.isManypoint) {
                for (let i = 0; i < data.length; i++) {
                    if (i === 0) {
                        //第一行必须存在，以第一行为基准
                        this.streetArr2.push(1); //合并医院
                        this.streeIndex2 = 0;
                    } else {
                        // 判断当前元素与上一元素是否相同
                        // 合并街区列
                        if (data[i].activityId == data[i - 1].activityId) {
                        this.streetArr2[this.streeIndex2] += 1;
                        this.streetArr2.push(0);
                        } else {
                        this.streetArr2.push(1);
                        this.streeIndex2 = i;
                        }
                    }
                }
            }
        },
        objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
            if (this.isManypoint) {
                if (columnIndex === 0  || columnIndex === 4 ) {
                    //第一列 医院
                    const _row_1 = this.streetArr2[rowIndex];
                    const _col_1 = _row_1 > 0 ? 1 : 0;
                    return {
                    rowspan: _row_1,
                    colspan: _col_1,
                    };
                }
            }
        },
        // 初始化合并行数组
        mergeInit3() {
            this.streetArr3 = []; //合并街道
            this.streeIndex3 = 0; //合并街道索引
        },
    //  合并表格
        merge3(data) {
            this.mergeInit3();
            if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    if (i === 0) {
                        //第一行必须存在，以第一行为基准
                        this.streetArr3.push(1); //合并
                        this.streeIndex3 = 0;
                    } else {
                        // 判断当前元素与上一元素是否相同
                        // 合并街区列
                        if (data[i].pocName == data[i - 1].pocName) {
                        this.streetArr3[this.streeIndex3] += 1;
                        this.streetArr3.push(0);
                        } else {
                        this.streetArr3.push(1);
                        this.streeIndex3 = i;
                        }
                    }
                }
            }
        },
        objectSpanMethod3({ row, column, rowIndex, columnIndex }) {
            if (this.isManypoint) {
                if (columnIndex === 0  || columnIndex === 1 ) {
                    //第一列 医院
                    const _row_1 = this.streetArr3[rowIndex];
                    const _col_1 = _row_1 > 0 ? 1 : 0;
                    return {
                    rowspan: _row_1,
                    colspan: _col_1,
                    };
                }
            } else {
                if (columnIndex === 0) {
                    const _row_1 = this.streetArr3[rowIndex];
                    const _col_1 = _row_1 > 0 ? 1 : 0;
                    return {
                    rowspan: _row_1,
                    colspan: _col_1,
                    };
                }
            }
        },
        changeInput (row) {
            if (row) {
                for (let item of this.updatedList) {
                    item.bwContactPerson = row.bwContactPerson
                }
            }
        },
        // 审批中row修改
        showUpdate (row) {
            // console.log(row,'row');
            this.lockScroll()
            this.signInfo = false
            this.isMask = true
            this.rowActivityId = row.activityId
            this.rowAreacode = row.areaCode
            for (let item of this.detailDTOList) {
                if (item.regionCode == row.regionCode) {
                    this.rowNumber = item.notReportCountQty
                    this.rowApprovalnunumber = item.approvalCountQty
                }

            }
            let arr = []
            if (this.isSinglepoint) {
                arr.push(row)
                this.updatedList =  JSON.parse(JSON.stringify(arr))
                this.isUpdatesingle = true
            } else if (this.isManypoint) {
                for (let item1 of this.tableData) {
                    if (item1.activityId == row.activityId) {
                        arr.push(item1)
                    }
                }
                this.updatedList =  JSON.parse(JSON.stringify(arr))
                this.merge2(this.updatedList)
                this.isUpdatemany = true
            } else {
                return
            }
        },
        // 审批中row修改弹窗关闭
        closeSure () {
            this.rowNumber = ''
            this.rowApprovalnunumber = ''
            this.rowActivityId = ''
            this.rowAreacode = ''
            this.updatedList = []
            this.isMask = false
            this.isUpdatesingle = false
            this.isUpdatemany = false
            this.unlockScroll()
        },
        // 审批中row修改弹窗确认
        updateSure () {
            this.isMask = false
            this.unlockScroll()
            if (this.isSinglepoint) {
                this.isUpdatesingle = false
                this.handleChange(this.updatedList)
            } else if ( this.isManypoint) {
                this.isUpdatemany = false
                this.handleSelectionChange(this.updatedList)
            } else{
                return
            }
            this.rowActivityId = ''
            this.rowAreacode = ''
            this.updatedList = []
        },
        getTime (timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return ''
            } else {
                var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
                const Y = date.getFullYear() + '-'
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
                // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
                // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
                return Y + M + D
            }
        },
        lockScroll() {
            let widthBar = 17, root = document.documentElement;
            if (typeof window.innerWidth == 'number') {
                widthBar = window.innerWidth - root.clientWidth;
            }
            root.style.overflow = 'hidden';
            root.style.borderRight = widthBar + 'px solid transparent';
        },

        unlockScroll() {
            let root = document.documentElement;
            root.style.overflow = '';
            root.style.borderRight = '';
        },
        getDecorates(a,b){
            let arr = a.map((item) => {
                    return item.decorateName
                }).join(b)
            return arr
        },
        // 删除售点
        async deletePoc (val) {
            let res = await gameplanApi.deletePocinformation(val[0])
            if (res.data.resultCode == '0') {
                this.$message.success("删除成功")
                this.$emit('activityChanged')
                this.getDetailinfo()
            }
        },
        // 修改售点
        async updatePoc (val) {
            let res = await gameplanApi.updatePocinformation(val[0])
            if (res.data.resultCode == '0') {
                this.$message.success("修改成功")
                this.$emit('activityChanged')
                this.getDetailinfo()
            } else {
                this.$emit('activityChanged')
                this.getDetailinfo()
            }
        },
        handleCurrentChange (val) {
            this.searchForm.page = val

        },
        // 初始化合并行数组
        mergeInit() {
        this.streetArr = []; //合并街道
        this.streeIndex = 0; //合并街道索引
        },
    //  合并表格
        merge(data) {
            this.mergeInit();
            if (data.length > 0 && this.isManypoint) {
                for (let i = 0; i < data.length; i++) {
                    if (i === 0) {
                        //第一行必须存在，以第一行为基准
                        this.streetArr.push(1); //合并医院
                        this.streeIndex = 0;
                    } else {
                        // 判断当前元素与上一元素是否相同
                        // 合并街区列
                        if (data[i].activityId == data[i - 1].activityId) {
                        this.streetArr[this.streeIndex] += 1;
                        this.streetArr.push(0);
                        } else {
                        this.streetArr.push(1);
                        this.streeIndex = i;
                        }
                    }
                }
            }
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            const len = this.tableData.length;
            if (this.isManypoint) {
                if (this.queryCondition !== '03') {
                    if (columnIndex === 0 ||columnIndex === 1 ||columnIndex === 2 || columnIndex === 3 || columnIndex === 6 || columnIndex === 7 || columnIndex === 8 || columnIndex === 9) {
                        const _row_1 = this.streetArr[rowIndex];
                        const _col_1 = _row_1 > 0 ? 1 : 0;
                        return {
                        rowspan: _row_1,
                        colspan: _col_1,
                        };
                    } else if(rowIndex === len){
                        return {
                        rowspan:1,
                        colspan:1
                        }
                    }
                } else {
                    if (columnIndex === 0 ||columnIndex === 1 ||columnIndex === 2 || columnIndex === 3 || columnIndex === 6 || columnIndex === 8 || columnIndex === 9 || columnIndex === 10 ) {
                        const _row_1 = this.streetArr[rowIndex];
                        const _col_1 = _row_1 > 0 ? 1 : 0;
                        return {
                        rowspan: _row_1,
                        colspan: _col_1,
                        };
                    } else if(rowIndex === len){
                        return {
                        rowspan:1,
                        colspan:1
                        }
                    }
                }
            }
        },
        clickStorename (row) {
            this.$emit("clickStorename",row)
        },
        //修改
        clickOperate (row) {
            // console.log(row);
            // console.log(this.igniteRuleDTOList,'igniteRuleDTOList');
            for (let item of this.igniteRuleDTOList) {
                if (row.regionCode == item.regionCode) {
                    this.ingiteNew = item.igniteRuleObj
                }
            }
            if (this.ingiteNew == null) {
                this.ingiteNew = {
                    "igniteStatus": [],
                    "openStatus": [],
                    "channel": [],
                    "bizForm": [],
                    "subBizForm": null,
                    "pocGrade": [],
                    "salesVolume": [],
                    "pocName": null,
                    "themeDetailId": null
                }
            }
            this.lockScroll()
            this.regionCodenew = row.regionCode
            this.rowActivityId = row.activityId
            this.rowAreacode = row.areaCode
            this.rowBwContactPerson = row.bwContactPerson
            this.signInfo = true
            for (let item of this.detailDTOList) {
                if (item.regionCode == row.regionCode) {
                    this.rowNumber = item.notReportCountQty
                    this.rowApprovalnunumber = item.approvalCountQty
                }

            }
            if (this.isSinglepoint) {
                this.rowActivityList  = row
                // console.log( this.rowActivityList,'rowActivityList-isSinglepoint');
                let arr = []
                arr.push(row)
                this.addSale(arr)
            } else if (this.isManypoint) {
                this.rowBlockname = row.blockName
                let arr = []
                for (let item of this.tableData) {
                    if (item.activityId == row.activityId ) {
                        arr.push(item)
                    }
                }
                let reviseObj = {
                    'selectList':arr,
                    'foodStreet':row.blockName,
                    'bwContactPerson':row.bwContactPerson,
                    'areaCode':row.areaCode,
                    'timeList':row.timeList
                }
                this.addSale(reviseObj)
            } else {
                let arr = []
                arr.push(row)
                this.addSale(arr)
            }
        },
        addSale (val) {
            let reviseObj = val
            let obj = {
                'themeCode' : this.themeDetail.themeStyleCode,
                'themeDetailId':this.themeDetail.themeDetailId,
                // 'igniteRuleObj':this.igniteRuleDTOList[0].igniteRuleObj,
                'igniteRuleObj':this.ingiteNew,
                'pocCountMin':this.pocCountMin,
                'pocRelateType':this.themeDetail.pocRelateType,
                'reviseObj': reviseObj,
                'singleData': [],
                'router':'06',
                'regionCode':this.regionCodenew,
                // 'regionCode':this.regionCode,
                'areaCode':this.rowAreacode,
                'needTransitions':this.themeDetail.needTransitions,
                'perExecDays':this.themeDetail.perExecDays,
                'themeBasic':this.themeBasic,
            }
            this.searchList = obj
            if (this.isSinglepoint) {
                this.isSingledialog = true
                this.isMask = true

            } else if (this.isManypoint) {
                this.isMask = true
                this.isManydialog = true

            } else if (this.isEmptypoint) {
                this.isMask = true
                this.isEmptydialog = true
            }
        },
        //删除
        deleteRow (row) {
            // console.log(row,'删除-deleteRow');
            let popData =  this.popData
            let themeBasic = this.themeBasic
            if (this.isEmptypoint) {
                let arr  = [
                    {
                        "gpActivityInfoDTO":
                        {
                            "activityId":row.activityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":row.blockName,
                            "areaCode":row.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":row.blockAddress,
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                            "assignStartTime":  this.searchForm.beginTime,
                            "assignEndTime":  this.searchForm.endTime,
                        }
                        ,
                        "gpActivityPocDTOList": []
                    }
                ]
                // console.log(arr,'arr-deleteRow-isEmptypoint');
                this.deletePoc(arr)
            } else if (this.isSinglepoint) {
                let arr  = [
                    {
                        "gpActivityInfoDTO":
                        {
                            "activityId":row.activityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":'',
                            "areaCode":row.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":'',
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                            "assignStartTime":  this.searchForm.beginTime,
                            "assignEndTime":  this.searchForm.endTime,
                        }
                        ,
                        "gpActivityPocDTOList":
                        [{
                            "activityPocId":row.activityPocId,
                            "cityName": row.cityName,
                            "contactPerson": row.contactPerson,
                            "contactPhone": row.contactPhone,
                            "igniteId": row.igniteId,
                            "pocAddress": row.pocAddress,
                            "pocName": row.pocName,
                            "pocPoiId": row.pocPoiId,
                            "provinceName": row.cityName,
                            "locLongitude":row.locLongitude,
                            "locLatitude":row.locLatitude,
                            'pocDetail':row.pocDetail
                        }]
                    }
                ]
                // console.log(arr,'arr-deleteRow-isSinglepoint');
                this.deletePoc(arr)
            } else if (this.isManypoint) {
                let itemArr = []
                for (let i = 0; i < this.tableData.length; i++) {
                    // console.log(this.tableData[i],'item');
                    if (this.tableData[i].activityId == row.activityId) {
                        // itemArr.push(this.tableData[i])
                        itemArr.push({
                            "activityPocId":this.tableData[i].activityPocId,
                            "cityName": this.tableData[i].cityName,
                            "contactPerson": this.tableData[i].contactPerson,
                            "contactPhone": this.tableData[i].contactPhone,
                            "igniteId": this.tableData[i].igniteId,
                            "pocAddress": this.tableData[i].pocAddress,
                            "pocName": this.tableData[i].pocName,
                            "pocPoiId": this.tableData[i].pocPoiId,
                            "provinceName": this.tableData[i].cityName,
                            "locLongitude":this.tableData[i].locLongitude,
                            "locLatitude":this.tableData[i].locLatitude,
                            'pocDetail':this.tableData[i].pocDetail
                        })
                    }
                }
                let arr  = [
                    {
                        "gpActivityInfoDTO":
                        {
                            "activityId":row.activityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":row.blockName,
                            "areaCode":row.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":'',
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                            "assignStartTime":  this.searchForm.beginTime,
                            "assignEndTime":  this.searchForm.endTime,
                        }
                        ,
                        "gpActivityPocDTOList": itemArr
                    }
                ]
                // console.log(arr,'arr-deleteRow-isManypoint');
                this.deletePoc(arr)
            } else {
                return
            }
        },
        closeMask () {
            this.unlockScroll()
            this.ingiteNew = null
            this.rowNumber = ''
            this.rowApprovalnunumber = ''
            this.regionCodenew = ''
            this.rowActivityId = ''
            this.rowBlockname = ''
            this.rowAreacode = ''
            this.rowBwContactPerson = ''
            this.isMask = false
            this.isSingledialog = false
            this.isManydialog = false
            this.isEmptydialog = false
        },
        handleChange (val) {
            // console.log(val,'9999-单');
            let tableList = val
            let tableArr = []
            let popData =  this.popData
            let themeBasic = this.themeBasic
            let timeArr = []
            for (let item of tableList) {
                for (let item2 of item.timeList) {
                        timeArr.push({
                            'activityTime':item2
                        })
                    }
                    tableArr.push({
                        'isUpdate':this.signInfo,
                        "gpActivityInfoDTO":
                        {
                            "activityId":this.rowActivityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":'',
                            "areaCode":item.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":'',
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                            'bwContactPerson':item.bwContactPerson,
                            "assignStartTime":  this.searchForm.beginTime,
                            "assignEndTime":  this.searchForm.endTime,
                            'regionCode':item.regionCode,
                            'notReportCountQty':this.rowNumber,
                            'needTransitions':this.themeDetail.needTransitions,
                            'perExecDays':this.themeDetail.perExecDays,
                            'approvalCountQty':this.rowApprovalnunumber,
                        }
                        ,
                        "gpActivityPocDTOList":
                        [{
                            "activityPocId":item.activityPocId,
                            "cityName": item.cityName,
                            "contactPerson": item.contactPerson,
                            "contactPhone": item.contactPhone,
                            "igniteId": item.igniteId,
                            "pocAddress": item.pocAddress,
                            "pocName": item.pocName,
                            "pocPoiId": item.pocPoiId,
                            "provinceName": item.cityName,
                            "locLongitude":item.locLongitude,
                            "locLatitude":item.locLatitude,
                            'pocDetail':item.pocDetail
                        }],
                        'gpActivityTimeDTOList':timeArr
                    })
            }
            // console.log(tableArr,'tableArr');
            this.updatePoc(tableArr)

        },
        arrHandle (arr) {
            let popData =  this.popData
            let themeBasic = this.themeBasic
            let array =JSON.parse(JSON.stringify(arr))
            let result = []
            array.map(e => {
                return {
                    'isUpdate':this.signInfo,
                    gpActivityTimeDTOList:e.timeList.map(time =>{
                        return {
                            'activityTime':time
                        }
                    }),
                    gpActivityInfoDTO: {
                        "activityId":this.rowActivityId,
                        "beginTime": themeBasic.themeStartTime,
                        "buToCity": themeBasic.buToCity,
                        "endTime": themeBasic.themeEndTime,
                        "themeChannelCode": popData.themeDetail.themeChannelCode,
                        "themeId": themeBasic.themeId,
                        "themeLevelCode":  popData.themeDetail.themeLevelCode,
                        "themeStyleCode":  popData.themeDetail.themeStyleCode,
                        'themeDetailId': popData.themeDetail.themeDetailId,
                        "blockName":e.block_name,
                        "areaCode":e.areaCode, // 新加
                        "blockPoi":'',
                        "blockAddress":'',
                        "blockLongitude":'',
                        "blockLatitude":'',
                        "signInLongitude":'',
                        "signInLatitude":'',
                        'bwContactPerson':e.bwContactPerson,
                        "assignStartTime":  this.searchForm.beginTime,
                        "assignEndTime":  this.searchForm.endTime,
                        'regionCode':e.regionCode,
                        'notReportCountQty':this.rowNumber,
                        'needTransitions':this.themeDetail.needTransitions,
                        'perExecDays':this.themeDetail.perExecDays,
                        'approvalCountQty':this.rowApprovalnunumber,
                    },
                    gpActivityPocDTOList: array.filter(g => g.block_name == e.block_name).map(h => {
                        return {
                            "activityPocId":h.activityPocId,
                            "cityName": h.cityName,
                            "contactPerson": h.contactPerson,
                            "contactPhone": h.contactPhone,
                            "igniteId": h.igniteId,
                            "pocAddress": h.pocAddress,
                            "pocName": h.pocName,
                            "pocPoiId": h.pocPoiId,
                            "provinceName": h.cityName,
                            "locLongitude":h.locLongitude,
                            "locLatitude":h.locLatitude,
                            'pocDetail':h.pocDetail
                        }
                    })
                    }
                    }).forEach(e => {
                        result.push(e)
                        // result.findIndex(f => f.gpActivityInfoDTO?.block_name == e.gpActivityInfoDTO?.block_name) == -1 && result.push(e)
                    });
            for (let i = 0; i < result.length; i++) {
                for (let j = 0; j < i; j++) {
                    if (result[i].gpActivityInfoDTO.blockName == result[j].gpActivityInfoDTO.blockName) {
                        result.splice(j,1)
                        i--
                    }
                }
            }
            // console.log(result,'result--详情-审批中-多售点组装');
            this.updatePoc(result)

        } ,
        handleSelectionChange (val) {
            // console.log(val,'9999-多');
            this.arrHandle(val)
        },
        handleEmptyChange (val) {
            // console.log(val,'9999-空');
            let tableList = val
            let tableArr = []
            let popData =  this.popData
            let themeBasic = this.themeBasic
            // for (let i = 0; i < this.tableData.length; i++) {
            //     if (this.tableData[i].blockName == tableList[0].block_name && this.tableData[i].blockAddress == tableList[0].pocAddress && this.tableData[i].areaCode == tableList[0].areaCode && this.tableData[i].bwContactPerson == tableList[0].bwContactPerson  ) {
            //         this.$message.warning('街区售点已存在，请重新选择')
            //         return
            //     }
            // }
            let timeArr = []
            for (let item of tableList) {
                for (let item2 of item.timeList) {
                        timeArr.push({
                            'activityTime':item2
                        })
                    }
                    tableArr.push({
                        'isUpdate':this.signInfo,
                        "gpActivityInfoDTO":
                        {
                            "activityId":this.rowActivityId,
                            "beginTime": themeBasic.themeStartTime,
                            "buToCity": themeBasic.buToCity,
                            "endTime": themeBasic.themeEndTime,
                            "themeChannelCode": popData.themeDetail.themeChannelCode,
                            "themeId": themeBasic.themeId,
                            "themeLevelCode":  popData.themeDetail.themeLevelCode,
                            "themeStyleCode":  popData.themeDetail.themeStyleCode,
                            'themeDetailId': popData.themeDetail.themeDetailId,
                            "blockName":item.block_name,
                            "areaCode":item.areaCode, // 新加
                            "blockPoi":'',
                            "blockAddress":item.pocAddress,
                            "blockLongitude":'',
                            "blockLatitude":'',
                            "signInLongitude":'',
                            "signInLatitude":'',
                            'bwContactPerson':item.bwContactPerson,
                            "assignStartTime":  this.searchForm.beginTime,
                            "assignEndTime":  this.searchForm.endTime,
                            'regionCode':item.regionCode,
                            'notReportCountQty':this.rowNumber,
                            'needTransitions':this.themeDetail.needTransitions,
                            'perExecDays':this.themeDetail.perExecDays,
                            'approvalCountQty':this.rowApprovalnunumber,
                        }
                        ,
                        "gpActivityPocDTOList": [],
                        'gpActivityTimeDTOList':timeArr
                    })
            }
            // console.log(tableArr,'tableArr');
            this.updatePoc(tableArr)
        },
        checkApprovalSelected(approval) {
        return approval.imageApprovalId === this.imageApprovalInfo.imageApprovalId
        },
        getActivestep (approval) {
            // console.log(approval,'approval-step');
            const evidenceStatus = approval.evidenceStatus
            if (!evidenceStatus) {
                return 0
            }
            if (evidenceStatus === 0) {
                return 0
            }
            if (evidenceStatus === 100) {
                return 1
            }
            // if (evidenceStatus === 200) {
            //     return 1
            // }
            // if (evidenceStatus === 300) {
            //     return 2
            // }
            // if (evidenceStatus === 400) {
            //     return 3
            // }
            // if (evidenceStatus === 500) {
            //     return 4
            // }
            if (evidenceStatus === 200 && this.orgLevel == 'region' ) {
                return 1
            }
            if (evidenceStatus === 300 && this.orgLevel == 'bu' ) {
                return 1
            }
            if (evidenceStatus === 400 && this.orgLevel == 'hq' ) {
                return 1
            }
            if (evidenceStatus === 500) {
                return 2
            }
            return 0
        },
        viewApprovalImage(approval) {
            this.imageApprovalInfo = approval
        },
        getDateTime(timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return "";
            } else {
                var date = new Date(parseInt(timestamp)); // 时间戳为13位的话需要parseInt下
                const Y = date.getFullYear() + "-";
                const M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
                const D =
                (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
                const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
                const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
                return Y + M + D + h + m + s;
            }
        },
        getImgList(dataList) {
            const imgList = []
            if (!dataList) {
                return []
            }
            dataList.forEach(item => {
                imgList.push(this.getImg(item.imageUri))
            })
            return imgList
        },
        getImg (uri) {
            return commonUtils.getImageUrl(uri)
        },
    }
}
</script>
<style lang="scss">
    .elDatePicker {
        .el-date-table td.selected span {
            background-color: rgb(222, 101, 45);
            color: #FFF;
            border-radius: 15px;
        }
        .el-picker-panel__footer {
            display: none;
        }
    }
</style>
<style lang="scss" scoped>
.tab-item-pop {
    padding: 0px 0px 15px 0px;
    color: #101010;
    font-size: 14px;
    text-align: left;
    ::v-deep.el-tabs__item.is-active {
        background-color: #FFFFFF;
        color: #409EFF;
    }
    .item-sale3 {
        .top-item {
            display: flex;
            justify-content: space-between;
            line-height: 40px;
            .title {
                flex: 1;
                text-align: left;
                color: #101010;
                font-size: 18px;
                font-weight: 600;
            }
            .his-btn {
                margin: 5px 0px;
                width: 149px;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                text-align: center;
                border-radius: 4px;
                cursor: pointer;
                border: 1px solid #cd1231;
                background-color: #FFFFFF ;
                color:#cd1231;
            }
        }
        .item-sale3-div2 {
            padding:0px 20px 10px;
            background-color: #FFFFFF ;
            border-radius: 8px;
            .div-time {
                font-size: 14px;
                display: flex;
                justify-content: flex-start;
                line-height: 40px;
                .time-left {
                    width: 150px;
                    font-weight: 600;
                    text-align: right;
                    margin-right: 50px;
                }
                .time-right {
                    flex: 1;
                    font-size: 14px;
                }

            }
            ::v-deep .el-table th.el-table__cell {
                color: #101010;
                background-color: rgba(232, 232, 232);
            }
            ::v-deep .el-table__body tr.current-row>td.el-table__cell {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
                background-color: #FFFFFF !important;
            }
            ::v-deep .el-date-table td.selected span{
                background-color: #cd1231;
                color: #FFF;
                border-radius: 15px;
            }
            .store-name {
                color: #409EFF;
                white-space: nowrap;/*设置不换行*/
                overflow: hidden; /*设置隐藏*/
                text-overflow: ellipsis; /*设置隐藏部分为省略号*/
                cursor: pointer;
                line-height: 32px;
                height: 32px;
            }

            .dialog-bottom {
                position: relative;
                top: 10px;
                text-align: right;
                // ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
                // background-color: #fff;
                // color: #409EFF;
                // border: 1px solid #409EFF
                // }
                // ::v-deep .el-pagination.is-background .el-pager li:hover {
                // color: #409EFF;
                // }
                ::v-deep .el-pagination.is-background .btn-next,
                ::v-deep .el-pagination.is-background .btn-prev{
                    background-color: #FFFFFF;
                    color: #000;
                    // width: 66px;
                    border: 1px solid #C0C4CC;
                    border-radius: 3px;
                }
                ::v-deep .el-pagination.is-background .btn-next:disabled,
                ::v-deep .el-pagination.is-background .btn-prev:disabled,
                ::v-deep .el-pagination.is-background .el-pager li.disabled {
                    color: #C0C4CC;
                }
            }
            // .time-item {
            //     .pickerOptionsNo {
            //         .date-picker {
            //             .el-picker-panel__footer {
            //                 display: none;
            //             }
            //         }
            //     }

            // }
        }
    }
}
.report {
    .title {
        line-height: 40px;
        text-align: left;
        color: #101010;
        font-size: 18px;
        font-weight: 600;
    }
    .report-main {
        ::v-deep .el-table th.el-table__cell {
            color: #101010;
            background-color: rgba(232, 232, 232);
        }
        ::v-deep .el-table__body tr.current-row>td.el-table__cell {
            background-color: #FFFFFF !important;
        }
        ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
            background-color: #FFFFFF !important;
        }
    }
}
.photoPop {
    .title {
        line-height: 40px;
        text-align: left;
        color: #101010;
        font-size: 18px;
        font-weight: 600;
    }
    .photo-approval {
        .photo-approval-card {
            padding: 20px 20px 30px 20px;
            background-color: #ffffff;
            font-size: 15px;
            border-radius: 10px;
            margin-bottom: 10px;
        }
        .photo-approval-card-selected {
            background-color: #ececec;
        }
        .approval-request-time {
            color: #cd1231;
            font-weight: 700;
            padding: 0 0 20px 0;
            line-height: 32px;
        }
        .approval-code {
            text-align: right;
            font-size: 12px;
            color: #999999;
        }
        .approval-view-link {
            text-align: right;
            color: #cd1231;
            font-weight: 700;
            padding: 30px 0 0 0;
            span {
                cursor: pointer;
            }
        }
    }
    .photo-fieldBuild {
        margin-top: 30px;
        .title {
        line-height: 50px;
        color: #101010;
        font-size: 18px;
        text-align: left;
        font-weight: 600;
        font-family: SourceHanSansSC-bold;
        display: flex;
        .right {
            width: 66px;
            height: 21px;
            line-height: 21px;
            margin-top: 15px;
            border-radius: 4px;
            background-color: #ffeaa6;
            color: #d19f00;
            font-size: 12px;
            text-align: center;
            margin-left: 5px;
        }
        }
        .photo-fieldBuild-card1 {
            padding: 10px 20px;
            background-color: #ffffff;
            font-size: 14px;
            color: #101010;
            position: relative;
            border-radius: 10px;
            .card-item {
                font-weight: bold;
                display: flex;
                flex-wrap: wrap;
                .top {
                line-height: 30px;
                text-align: left;
                }
            }
        }

        .photo-fieldBuild-card2 {
            padding: 10px 20px;
            background-color: #ffffff;
            font-size: 14px;
            color: #101010;
            display: flex;
            flex-wrap: wrap;
            position: relative;
            border-radius: 10px;
            margin-bottom: 5px;
            .card-item {
                width: 579px;
                font-weight: bold;
                margin-top: 15px;
                .top {
                line-height: 30px;
                text-align: left;
                }
            }
            .execution-time {
                position: absolute;
                top: 5px;
            }
        }
        .photo {
            display: flex;
            flex-wrap: wrap;
            .photo-item {
                margin-right: 10px;
                margin-bottom: 10px;
                width: 100px;
                height: 100px;
                cursor: pointer;
                overflow:hidden;
                max-width: 100px;
                max-height: 100px;
                .photo-item-image {
                    width:100%;
                    // height:100%;
                    background-position:center center;
                    background-repeat: no-repeat;
                    -webkit-background-size:cover;
                    -moz-background-size:cover;
                    background-size:cover;
                }
            }
        }
    }
}

.mask{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0,0,0,.7) ;
    z-index: 3;
}

.dialog {
    position: fixed;
    top: 5vh;
    left: calc((100vw - 1000px)/2);
    width: 1000px;
    // height: 300px;
    padding: 20px;
    background-color: #FFFFFF;
    border-radius: 10px;
    z-index: 3;
    max-height: 90vh;
}
.dialog2 {
    position: fixed;
    top: 25%;
    left: calc((100vw - 600px)/2);
    width: 600px;
    // height: 300px;
    padding: 20px;
    background-color: #FFFFFF;
    border-radius: 10px;
    z-index: 3;
}
.dialog-update{
    position: fixed;
    border-radius: 8px;
    width: 80%;
    top: 5%;
    left: 10%;
    // height: 100px;
    max-height: 500px;
    padding: 10px;
    background-color: #FFFFFF;
    z-index: 3;
    ::v-deep .el-table th.el-table__cell {
        color: #101010;
        background-color: rgba(232, 232, 232);
    }
    ::v-deep .el-table__body tr.current-row>td.el-table__cell {
        background-color: #FFFFFF !important;
    }
    ::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #FFFFFF !important;
    }
    .update-table{
        width: 80%;
        // padding: 10px;
        border-radius: 8px;

        .item-input {
            width: 140px;
        }
    }

    .dialog-btn2 {
        margin-top: 10px;
        height: 30px;
        line-height: 30px;
        display: flex;
        justify-content:flex-end;
        .btn-left {
            width: 80px;
            text-align: center;
            background-color: #FFFFFF;
            color: #cd1231;
            border-radius: 5px;
            border: 1px solid #cd1231;
            margin-right: 10px;
            cursor: pointer;
        }
        .btn-right {
            width: 80px;
            text-align: center;
            background-color: #cd1231;
            color: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #cd1231;
            cursor: pointer;
        }
    }
}
</style>
